import { Card, CardContent, makeStyles } from '@material-ui/core'
import React from 'react'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { isMotorInsurance } from 'src/utils/commonMethods'

export const Aggregate = ({
  premium,
  sumAssured,
  vehicleIdv,
  insuranceType,
}) => {
  const classes = useStyles()
  return (
    <Card className={classes.card}>
      <CardContent>
        <div className={classes.content}>
          <h2 className={classes.title}>
            <span>Aggregates</span>
          </h2>
          {/* Premium */}
          <div className={classes.listItem}>
            <div className={classes.label}>Premium</div>
            <div className={classes.value}>{formatToINR(premium)}</div>
          </div>

          {/* Vehicle IDV / Sum Assured */}
          {isMotorInsurance(insuranceType) ? (
            <div className={classes.listItem}>
              <div className={classes.label}>Vehicle IDV</div>
              <div className={classes.value}>{formatToINR(vehicleIdv)}</div>
            </div>
          ) : (
            <div className={classes.listItem}>
              <div className={classes.label}>Sum Assured</div>
              <div className={classes.value}>{formatToINR(sumAssured)}</div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
const useStyles = makeStyles({
  card: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    padding: '24px 0px 0px 0px',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '16px',
    marginTop: 'unset',
    color: '#333333',
    '& .MuiSelect-select': {
      padding: '0 14px 0 10px',
      fontWeight: 600,
      borderBottom: '1px solid #bbbbbb',
      borderRadius: 0,
    },
    '& fieldset': {
      border: '0px',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '16px',
    borderBottom: '1px solid #33333333',
    '&:last-child': {
      borderBottom: '0px solid #33333333',
    },
  },
  label: {
    fontSize: '13px',
    color: '#333333',
    marginBottom: '10px',
    lineHeight: '16px',
    padding: '0 10px',
  },
  value: {
    fontSize: '16px',
    color: '#B92250',
    fontWeight: 'bold',
    lineHeight: '20px',
  },
})
